import { Text } from "@wojo/ui";
import cn from "clsx";
import React, { useId } from "react";
import styles from "./TripList.module.scss";

export type TripListProps = React.PropsWithChildren<{
    className?: string;
    title?: string;
}>;

export const TripList: React.FC<TripListProps> = ({
    children,
    className,
    title,
}) => {
    const headingId = useId();
    return (
        <section aria-labelledby={headingId}>
            {title ? (
                <Text.Heading
                    id={headingId}
                    order="3"
                    tag="h2"
                    className={styles.title}
                >
                    {title}
                </Text.Heading>
            ) : null}
            <div className={cn(styles["trip-list"], className)}>{children}</div>
        </section>
    );
};
